export default __webpack_public_path__ + "assets/images/25d8c653dff433b47d97aa2132e81b50.svg";